export default __webpack_public_path__ + "static/media/longboard.2ee26646.jpeg";